import { CreateStaffVO, UpdateStaffVO } from "../models/staffsModel";
import { api } from "../services/axios";

const GetAllByServiceId = async (serviceId: string) => {
    try {
        var result = await api.get(`/HumanResources/GetAllByServiceId?serviceId=${serviceId}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetStaffById = async (staffId: string) => {
    try {
        var result = await api.get(`/HumanResources/GetStaffById?id=${staffId}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllToImportLastYear = async (serviceId: string) => {
    try {
        var result = await api.get(`/HumanResources/GetAllToImportLastYear?serviceId=${serviceId}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DownloadStaff = async (serviceId: string, downloadOption: number) => {
    try {
        var result = await api.get(`/HumanResources/Download?serviceId=${serviceId}&downloadOption=${downloadOption}`, {
            responseType: 'blob'
        });
        const contentDisposition = result.headers['content-disposition'];
        const contentType = result.headers['content-type'];

        let fileName = 'download-file';
        if (contentDisposition) {
            let match = contentDisposition.match(/filename="(.+?)"/);
            if (!match) match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
            if (match && match[1]) fileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
        }

        var blob = new Blob([result.data], { type: contentType });

        const fileURL = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        URL.revokeObjectURL(fileURL);
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const UploadStaff = async (file: Blob, serviceId: string) => {
    try {
        let formData = new FormData();

        formData.append("file", file);
        formData.append("serviceId", serviceId);

        var result = await api.post(`/HumanResources/Upload`, formData);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const CreateStaffAPI = async (staff: CreateStaffVO) => {
    try {
        var result = await api.post(`/HumanResources/CreateStaff`, staff);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const createSummaryStaffAPI = async (staff: any) => {
    try {
        var result = await api.post(`/HumanResources/createSummaryStaff`, staff);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const ImportStaffs = async (staffIdList: string, serviceId: string) => {
    try {
        var result = await api.post(`/HumanResources/ImportStaffs`, { staffIdList, serviceId });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const UpdateStaffAPI = async (staff: UpdateStaffVO) => {
    try {
        var result = await api.put(`/HumanResources/UpdateStaff`, staff);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteStaff = async (serviceId: string, staffId: string) => {
    try {
        var result = await api.delete(`/HumanResources/DeleteStaff?serviceId=${serviceId}&staffId=${staffId}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteAllStaff = async (serviceId: string) => {
    try {
        var result = await api.delete(`/HumanResources/DeleteAllStaff?serviceId=${serviceId}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteStaffsMassive = async (serviceId: string, staffIds: string[]) => {
    try {
        var result = await api.post(`/HumanResources/DeleteStaffsMassive`, { serviceId, staffIds });
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}


export {
    GetAllByServiceId,
    GetStaffById,
    GetAllToImportLastYear,
    DownloadStaff,
    UploadStaff,
    CreateStaffAPI,
    ImportStaffs,
    UpdateStaffAPI,
    DeleteStaff,
    DeleteAllStaff,
    createSummaryStaffAPI,
    DeleteStaffsMassive,
}
